import Link from 'next/link';
import { useTranslate } from '@tolgee/react';
import { SearchScope } from '@amf/shared/components/search/hooks/useAdvancedSearch';
import {
  SearchResultWithClubFragment,
  SearchResultWithGroundFragment,
} from '@amf/shared/types/graphql';

type Props = {
  item: SearchResultWithGroundFragment;
  prefixes: { ground: string };
};

function GroundResult({ item, prefixes }: Props) {
  const { t } = useTranslate();
  return (
    <Link href={`${prefixes.ground}/${item.id}`} passHref>
      <a className='AdvancedSearch__resultItem'>
        <div className='AdvancedSearch__resultItemImage'>
          <i className='icons-stadium' />
        </div>
        <div className='AdvancedSearch__resultItemContent'>
          <div className='AdvancedSearch__resultItemType'>
            {t(`search.scope.${SearchScope.GROUNDS}.one`)}
          </div>
          <h3 className='AdvancedSearch__resultItemTitle'>{item.name}</h3>
          <p className='AdvancedSearch__resultItemDescription'>{item.description}</p>
        </div>
      </a>
    </Link>
  );
}

export default GroundResult;
